<section class="px-4 py-4">
  <div *ngIf="action === 'view'; then View; else Form"></div>

  <ng-template #View>
    <div class="relative mb-4 sm:grid sm:grid-cols-2 md:grid-cols-3">
      <div class="col-start-1 sm:col-span-1 md:col-span-2">
        <h3 class="text-base font-semibold leading-7 text-gray-900">Información de la gama {{ target_gama.index ? target_gama.index + '/' + order.gamas.length : '-' }} orden <span [routerLink]="'/orders/view/' + order.id">{{ order.number }}</span></h3>
      <!--p class="mt-1 max-w-2xl text-sm leading-6 text-gray-500">Personal details and application.</p-->
        
      </div>
      <div class ="hidden sm:col-span-1 sm:flex sm:flex-row-reverse">
        <button [routerLink]="['/gamas/edit/' + target_gama.id]" fragment="top" type="submit" class="w-1/2 sm:w-2/3 md:w-full lg:w-2/3 rounded-md primary-button px-3 py-2 text-sm font-semibold text-white shadow-sm">
          Editar Información
        </button>
      </div>
    </div>
    <div class="mt-6 border-t border-gray-100">
      <dl class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
        <div class="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
          <dt class="text-sm font-medium leading-6 text-gray-900">Nº OT</dt>
          <dd [routerLink]="'/orders/view/' + order.id" class="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">{{ order.number }}</dd>
        </div>
        <div class="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
          <dt class="text-sm font-medium leading-6 text-gray-900">Nº Gama</dt>
          <dd class="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">{{ target_gama.index ? target_gama.index + '/' + order.gamas.length : '-' }}</dd>
        </div>
        <div class="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
          <dt class="text-sm font-medium leading-6 text-gray-900">S/C O Pedido</dt>
          <dd class="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">{{ target_gama.s_c_one ? target_gama.s_c_one  : '-' }}</dd>
        </div>
        <div class="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
          <dt class="text-sm font-medium leading-6 text-gray-900">AFFAIRE</dt>
          <dd class="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">{{ target_gama.affaire ? target_gama.affaire  : '-' }}</dd>
        </div>
        <div class="border-t border-gray-100 px-4 py-6 sm:col-span-4 sm:px-0">
          <dt class="text-sm font-medium leading-6 text-gray-900">Tratamiento</dt>
          <dd class="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">{{ target_gama.treatment ? target_gama.treatment : '-' }}</dd>
        </div>
      </dl>
    </div>

    <h2 class="mt-10 text-base font-semibold leading-7 text-gray-900 pb-2">Acciones</h2>
    <div class="py-3 sm:py-5 mx-auto">
      <div class="relative overflow-hidden bg-white shadow-md sm:rounded-lg">
        <div class="overflow-x-auto">
          <table class="w-full text-sm text-left text-gray-500">
            <thead class="text-xs text-gray-700 uppercase bg-gray-50">
              <tr>
                <th scope="col" class="px-4 py-3">Nº</th>
                <th scope="col" class="px-4 py-3">Operario</th>
                <th scope="col" class="px-4 py-3">Fecha</th>
                <th scope="col" class="px-4 py-3">Acción</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let action of target_gama.actions; let index = index" class="border-b border-gray-200 hover:bg-gray-50">
                <td fragment="top" scope="row" class="hover:cursor-pointer px-4 py-2">
                  <span class="bg-primary-100 text-primary-800 text-xs font-medium py-0.5 rounded">
                    {{ index + 1 }}
                  </span>
                </td>
                <td fragment="top" scope="row" class="hover:cursor-pointer px-4 py-2">
                  <span class="bg-primary-100 text-primary-800 text-xs font-medium py-0.5 rounded">
                    {{ action.worker.name }}
                  </span>
                </td>
                <td fragment="top" scope="row" class="hover:cursor-pointer px-4 py-2">
                  <span class="bg-primary-100 text-primary-800 text-xs font-medium py-0.5 rounded">
                    {{ action.creation_date ? dateService.formatDateTimeToSpanish(action.creation_date) : '-' }}
                  </span>
                </td>
                <td fragment="top" scope="row" class="hover:cursor-pointer px-4 py-2">
                  <span class="bg-primary-100 text-primary-800 text-xs font-medium py-0.5 rounded">
                    {{
                      action.type === 'start' ? 'Inicio' :
                      action.type === 'end' ? 'Fin' :
                      action.type === 'pause' ? 'Pausa' :
                      action.type === 'continue' ? 'Continuar' : '-'
                    }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    
    <h2 class="mt-10 text-base font-semibold leading-7 text-gray-900 pb-2">Designaciones</h2>
    <div class="py-3 sm:py-5 mx-auto">
      <div class="relative overflow-hidden bg-white shadow-md sm:rounded-lg">
        <div class="overflow-x-auto">
          <table class="w-full text-sm text-left text-gray-500">
            <thead class="text-xs text-gray-700 uppercase bg-gray-50">
              <tr>
                <th scope="col" class="px-4 py-3">Nº</th>
                <th scope="col" class="px-4 py-3">Designación</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let designation of target_gama.designations; let index = index" class="border-b border-gray-200 hover:bg-gray-50">
                <td fragment="top" scope="row" class="hover:cursor-pointer px-4 py-2">
                  <span class="bg-primary-100 text-primary-800 text-xs font-medium py-0.5 rounded">
                    {{ index + 1 }}
                  </span>
                </td>
                <td fragment="top" scope="row" class="hover:cursor-pointer px-4 py-2">
                  <span class="bg-primary-100 text-primary-800 text-xs font-medium py-0.5 rounded">
                    {{ designation }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <h2 class="mt-10 text-base font-semibold leading-7 text-gray-900 pb-2">Operaciones</h2>
    <div class="py-3 sm:py-5 mx-auto">
      <div class="relative overflow-hidden bg-white shadow-md sm:rounded-lg">
        <div class="overflow-x-auto">
          <table class="w-full text-sm text-left text-gray-500">
            <thead class="text-xs text-gray-700 uppercase bg-gray-50">
              <tr>
                <th scope="col" class="px-4 py-3">Nº</th>
                <th scope="col" class="px-4 py-3">Fecha</th>
                <th scope="col" class="px-4 py-3">Nombre</th>
                <th scope="col" class="px-4 py-3">Máquina</th>
                <th scope="col" class="px-4 py-3">Operación</th>
                <th scope="col" class="px-4 py-3">Tiempo</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let operation of target_gama.operations; let index = index" class="border-b border-gray-200 hover:bg-gray-50">
                <td fragment="top" scope="row" class="hover:cursor-pointer px-4 py-2">
                  <span class="bg-primary-100 text-primary-800 text-xs font-medium py-0.5 rounded">
                    {{ index + 1 }}
                  </span>
                </td>
                <td fragment="top" scope="row" class="hover:cursor-pointer px-4 py-2">
                  <span class="bg-primary-100 text-primary-800 text-xs font-medium py-0.5 rounded">
                    {{ operation.date }}
                  </span>
                </td>
                <td fragment="top" scope="row" class="hover:cursor-pointer px-4 py-2">
                  <span class="bg-primary-100 text-primary-800 text-xs font-medium py-0.5 rounded">
                    {{ operation.name }}
                  </span>
                </td>
                <td fragment="top" scope="row" class="hover:cursor-pointer px-4 py-2">
                  <span class="bg-primary-100 text-primary-800 text-xs font-medium py-0.5 rounded">
                    {{ operation.machine }}
                  </span>
                </td>
                <td fragment="top" scope="row" class="hover:cursor-pointer px-4 py-2">
                  <span class="bg-primary-100 text-primary-800 text-xs font-medium py-0.5 rounded">
                    {{ operation.operation }}
                  </span>
                </td>
                <td fragment="top" scope="row" class="hover:cursor-pointer px-4 py-2">
                  <span class="bg-primary-100 text-primary-800 text-xs font-medium py-0.5 rounded">
                    {{ operation.time }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <h2 class="mt-10 text-base font-semibold leading-7 text-gray-900 pb-2">Materiales</h2>
    <div class="py-3 sm:py-5 mx-auto">
      <div class="relative overflow-hidden bg-white shadow-md sm:rounded-lg">
        <div class="overflow-x-auto">
          <table class="w-full text-sm text-left text-gray-500">
            <thead class="text-xs text-gray-700 uppercase bg-gray-50">
              <tr>
                <th scope="col" class="px-4 py-3">Nº</th>
                <th scope="col" class="px-4 py-3">S.</th>
                <th scope="col" class="px-4 py-3">REF</th>
                <th scope="col" class="px-4 py-3">Materiales</th>
                <th scope="col" class="px-4 py-3">KG</th>
                <th scope="col" class="px-4 py-3">Valoración</th>
                <th scope="col" class="px-4 py-3">Ubicación</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let material of target_gama.materials; let index = index" class="border-b border-gray-200 hover:bg-gray-50">
                <td fragment="top" scope="row" class="hover:cursor-pointer px-4 py-2">
                  <span class="bg-primary-100 text-primary-800 text-xs font-medium py-0.5 rounded">
                    {{ index + 1 }}
                  </span>
                </td>
                <td fragment="top" scope="row" class="hover:cursor-pointer px-4 py-2">
                  <span class="bg-primary-100 text-primary-800 text-xs font-medium py-0.5 rounded">
                    {{ material.s }}
                  </span>
                </td>
                <td fragment="top" scope="row" class="hover:cursor-pointer px-4 py-2">
                  <span class="bg-primary-100 text-primary-800 text-xs font-medium py-0.5 rounded">
                    {{ material.ref }}
                  </span>
                </td>
                <td fragment="top" scope="row" class="hover:cursor-pointer px-4 py-2">
                  <span class="bg-primary-100 text-primary-800 text-xs font-medium py-0.5 rounded">
                    {{ material.material }}
                  </span>
                </td>
                <td fragment="top" scope="row" class="hover:cursor-pointer px-4 py-2">
                  <span class="bg-primary-100 text-primary-800 text-xs font-medium py-0.5 rounded">
                    {{ material.weight }}
                  </span>
                </td>
                <td fragment="top" scope="row" class="hover:cursor-pointer px-4 py-2">
                  <span class="bg-primary-100 text-primary-800 text-xs font-medium py-0.5 rounded">
                    {{ material.review }}
                  </span>
                </td>
                <td fragment="top" scope="row" class="hover:cursor-pointer px-4 py-2">
                  <span class="bg-primary-100 text-primary-800 text-xs font-medium py-0.5 rounded">
                    {{ material.ubication.ubication_one && material.ubication.ubication_two ? material.ubication.ubication_one + ', ' + material.ubication.ubication_two : '' }}
                    {{ material.ubication.ubication_one && !material.ubication.ubication_two ? material.ubication.ubication_one : '' }}
                    {{ !material.ubication.ubication_one && material.ubication.ubication_two ? material.ubication.ubication_two : '' }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

      
    <!-- Button for windows < md -->
    <div class="mt-6 flex items-center gap-x-6 justify-center sm:hidden">
      <button [routerLink]="['/gamas/edit/' + target_gama.id]" fragment="top" type="submit" class="rounded-md primary-button px-12 py-2 text-sm font-semibold text-white shadow-sm ">
        Editar
      </button>
    </div>
    <!-- End button -->
  </ng-template>



  <ng-template #Form>
  <div class="grid grid-cols-12 grid-flow-row border-e-4 border-black divide-x-4 divide-y-4 divide-black">

    <!--##############################################################################################################
    #                                                      Fila 1                                                    #
    ###############################################################################################################-->
    <div class="col-span-5 border-t-4 border-s-4 border-black">
      <p class="headers">
        DESIGNACIÓN:
      </p>
    </div>

    <div class="col-span-3 row-span-5 flex items-center">
      <img src="../../../../assets/imgs/logos/logo.png" class="object-contain">
    </div>

    <div class="col-span-2">
      <p class="headers">
        O.T.:
      </p>
    </div>

    <div class="col-span-2">
      <p class="flex items-center h-full justify-center ms-2 text-lg font-semibold">
        {{ order.number ? order.number : '-' }}
      </p>
    </div>

    <!--##############################################################################################################
    #                                                      Fila 2                                                    #
    ###############################################################################################################-->
    <div class="col-span-5">
      <input [(ngModel)]="target_gama.designations[0]" class="w-full h-full px-3 py-2 appearance-none outline-none">
    </div>

    <div class="col-span-1">
      <p class="headers">
        S/C o Pedido:
      </p>
    </div>

    <div class="col-span-1">
      <input [(ngModel)]="target_gama.s_c_one" class="w-full h-full px-3 py-2 appearance-none outline-none">
    </div>

    <div class="col-span-1">
      <p class="headers">
        AFFAIRE:
      </p>
    </div>

    <div class="col-span-1">
      <input [(ngModel)]="target_gama.affaire" class="w-full h-full px-3 py-2 appearance-none outline-none">
    </div>

    <!--##############################################################################################################
    #                                                      Fila 3                                                    #
    ###############################################################################################################-->
    <div class="col-span-5">
      <input [(ngModel)]="target_gama.designations[1]" class="w-full h-full px-3 py-2 appearance-none outline-none">
    </div>

    <div class="col-span-2">
      <p class="headers">
        CLIENTE:
      </p>  
    </div>

    <div class="col-span-2">
      <p class="headers">
        {{ order.client ? order.client : '-' }}
      </p>
    </div>
    
    <!--##############################################################################################################
    #                                                      Fila 4                                                    #
    ###############################################################################################################-->
    <div class="col-span-5">
      <input [(ngModel)]="target_gama.designations[2]" class="w-full h-full px-3 py-2 appearance-none outline-none">
    </div>

    <div class="col-span-2">
      <p class="headers">
        GAMA Nº:
      </p>
    </div>
    
    <div class="col-span-2">
      <p class="headers">
        {{ target_gama.index ? target_gama.index + '/' + order.gamas.length : '-' }}
      </p>
    </div>

    <!--##############################################################################################################
    #                                                      Fila 5                                                    #
    ###############################################################################################################-->
    <div class="col-span-5">
      <input [(ngModel)]="target_gama.designations[3]" class="w-full h-full px-3 py-2 appearance-none outline-none">
    </div>

    <div class="col-span-2">
      <p class="headers">
        Plz ENTREGA:
      </p>
    </div>

    <div class="col-span-2">
      <p class="headers">
        {{ order.deliver_date ? dateService.formatDate(order.deliver_date) : '-' }}
      </p>
    </div>

    <!--##############################################################################################################
    #                                                      Fila 6                                                    #
    ###############################################################################################################-->
    <div class="col-span-1">
      <p class="headers">
        FECHA
      </p>
    </div>

    <div class="col-span-1">
      <p class="headers">
        NOMBRE
      </p>
    </div>
    
    <div class="col-span-1">
      <p class="headers">
        MÁQUINA
      </p>
    </div>

    <div class="col-span-8">
      <p class="headers justify-center">
        OPERACIONES
      </p>
    </div>
    
    <div class="col-span-1">
      <p class="headers justify-center">
        TIEMPO
      </p>
    </div>
  </div>

    <!--##############################################################################################################
    #                                                      Fila 7                                                    #
    ###############################################################################################################-->
  <div *ngFor="let operation of target_gama.operations; let i = index" class="grid grid-cols-12 grid-flow-row border-e-4 border-black divide-x-4 divide-y-4 divide-black">
    <div class="col-span-1 border-t-4 border-s-4 border-black">
      <input [(ngModel)]="operation.date" class="w-full h-full px-3 py-2 appearance-none outline-none">
    </div>

    <div class="col-span-1">
      <input [(ngModel)]="operation.name" class="w-full h-full px-3 py-2 appearance-none outline-none">
    </div>
    
    <div class="col-span-1">
      <input [(ngModel)]="operation.machine" class="w-full h-full px-3 py-2 appearance-none outline-none">
    </div>

    <div class="col-span-8">
      <input [(ngModel)]="operation.operation" maxlength="60" class="w-full h-full px-3 py-2 appearance-none outline-none">
    </div>
    
    <div class="col-span-1">
      <input [(ngModel)]="operation.time" class="w-full h-full px-3 py-2 appearance-none outline-none">
    </div>
  </div>

    <!--##############################################################################################################
    #                                                      Fila 8                                                    #
    ###############################################################################################################-->
  <div class="grid grid-cols-12 grid-flow-row border-e-4 {{ target_gama.materials.length === 0 ? 'border-b-4' : '' }} border-black divide-x-4 divide-y-4 divide-black">
    <div class="col-span-2 row-span-2 border-t-4 border-s-4 border-black">
      <p class="headers text-center justify-center">
        CONTROL FINAL
      </p>
    </div>

    <div class="col-span-4">
      <div class="grid grid-cols-3 divide-x-4 divide-black">
        <div class="col-span-1">
          <input class="w-full h-full px-3 py-2 appearance-none outline-none">
        </div>

        <div class="col-span-1">
          <input class="w-full h-full px-3 py-2 appearance-none outline-none">
        </div>

        <div class="col-span-1">
          <input class="w-full h-full px-3 py-2 appearance-none outline-none">
        </div>
      </div>
    </div>
    
    <div class="col-span-2">
      <p class="headers justify-center">
        TRATAMIENTO
      </p>
    </div>

    <div class="col-span-2">
      <p class="headers">
        Aparato Nº
      </p>
    </div>

    <div class="col-span-2 row-span-2">
      <p class="headers-top">
        Firma Control Calidad:
      </p>
    </div>

    <!--##############################################################################################################
    #                                                      Fila 9                                                    #
    ###############################################################################################################-->
    <div class="col-span-4">
      <div class="grid grid-cols-3 divide-x-4 divide-black mt-0.5">
        <div class="col-span-1">
          <input class="w-full h-full px-3 py-2 appearance-none outline-none">
        </div>

        <div class="col-span-1">
          <input class="w-full h-full px-3 py-2 appearance-none outline-none">
        </div>

        <div class="col-span-1">
          <input class="w-full h-full px-3 py-2 appearance-none outline-none">
        </div>
      </div>
    </div>
    
    <div class="col-span-2">
      <p class="headers justify-center">
        <input [(ngModel)]="target_gama.treatment" class="w-full h-full px-3 py-2 appearance-none outline-none">
      </p>
    </div>
    <div class="col-span-2">
      <div class="grid grid-cols-5 mt-0.5 divide-x-4 divide-black">
        <div>
          <input class="w-full h-full px-3 py-2 appearance-none outline-none">
        </div>
        <div>
          <input class="w-full h-full px-3 py-2 appearance-none outline-none">
        </div>
        <div>
          <input class="w-full h-full px-3 py-2 appearance-none outline-none">
        </div>
        <div>
          <input class="w-full h-full px-3 py-2 appearance-none outline-none">
        </div>
        <div>
          <input class="w-full h-full px-3 py-2 appearance-none outline-none">
        </div>
      </div>
    </div>

    <!--##############################################################################################################
    #                                                      Fila 10                                                   #
    ###############################################################################################################-->
    <div class="col-span-1">
      <p class="headers justify-center">
        S.
      </p>
    </div>

    <div class="col-span-1">
      <p class="headers justify-center">
        REF
      </p>
    </div>

    <div class="col-span-4">
      <p class="headers justify-center">
        MATERIALES
      </p>
    </div>

    <div class="col-span-1">
      <p class="headers justify-center">
        KG
      </p>
    </div>  

    <div class="col-span-3">
      <p class="headers justify-center">
        VALORACIÓN
      </p>
    </div>

    <div class="col-span-2">
      <p class="headers justify-center">
        UBICACIÓN
      </p>
    </div>
  </div>

  <!--##############################################################################################################
    #                                                      Fila 11                                                   #
    ###############################################################################################################-->
  <div *ngFor="let material of target_gama.materials; let i = index" class="grid grid-cols-12 grid-flow-row border-e-4 border-black {{ i === target_gama.materials.length -1 ? 'border-b-4' : '' }} divide-x-4 divide-y-4 divide-black">
    <div class="col-span-1 border-t-4 border-s-4 border-black">
      <input [(ngModel)]="material.s" class="w-full h-full px-3 py-2 appearance-none outline-none">
    </div>

    <div class="col-span-1">
      <input [(ngModel)]="material.ref" class="w-full h-full px-3 py-2 appearance-none outline-none">
    </div>

    <div class="col-span-4">
      <input [(ngModel)]="material.material" class="w-full h-full px-3 py-2 appearance-none outline-none">
    </div>

    <div class="col-span-1">
      <input [(ngModel)]="material.weight" class="w-full h-full px-3 py-2 appearance-none outline-none">
    </div>  

    <div class="col-span-3">
      <input [(ngModel)]="material.review" class="w-full h-full px-3 py-2 appearance-none outline-none">
    </div>

    <div class="col-span-1">
      <input [(ngModel)]="material.ubication.ubication_one" class="w-full h-full px-3 py-2 appearance-none outline-none">
    </div>
    <div class="col-span-1">
      <input [(ngModel)]="material.ubication.ubication_two" class="w-full h-full px-3 py-2 appearance-none outline-none">
    </div>
  </div>

    <!--##############################################################################################################
    #                                                      Buttons                                                   #
    ###############################################################################################################-->
    <div class="flex justify-between py-4">
      <div class="flex justify-start gap-x-3 mt-4">
        <button *ngIf="target_gama.operations.length > 1" (click)="addMaterial()" type="button" class="primary-button flex justify-center rounded-xl px-10 py-2.5 text-base font-semibold leading-6 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-700">
          Añadir columna Material
        </button>

        <button *ngIf="target_gama.materials.length > 1"  (click)="addOperation()" type="button" class="primary-button flex justify-center rounded-xl px-10 py-2.5 text-base font-semibold leading-6 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-700">
          Añadir columna Operación
        </button>
      </div>

      <div class="flex justify-end gap-x-3 mt-4">
        <button [disabled]="form_in_progress" [routerLink]="['/gamas/view/' + target_gama.id]" type="button" class="primary-button flex justify-center rounded-xl px-10 py-2.5 text-base font-semibold leading-6 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-700">
          Cancelar
        </button>
  
        <div *ngIf="action === 'create'; then Create; else Edit"></div>
        <ng-template #Create>
          <button [disabled]="form_in_progress" (click)="registerGama()" type="submit" class="primary-button flex justify-center rounded-xl px-10 py-2.5 text-base font-semibold leading-6 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-700">
            Crear nueva gama
          </button>
        </ng-template>
        
        <ng-template #Edit>
          <button [disabled]="form_in_progress" (click)="updateGama()" type="submit" class="primary-button flex justify-center rounded-xl px-10 py-2.5 text-base font-semibold leading-6 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-700">
            Actualiza gama
          </button>
        </ng-template>
      </div>
    </div>
  </ng-template>

</section>

